import {style} from 'typestyle'

export const CategoryListItem = style({
    display: 'block'
})

export const titleName = style({
    fontSize: 20,
    color: '#000000',
    letterSpacing: 0,
    lineHeight: '20px',
    fontWeight: 500,
    marginTop: 15,
    paddingLeft: 15,
    marginBottom: 14
})

export const findMore = style({
    textAlign: 'center',
    marginBottom: 15,
    marginTop: 15,
    fontSize: 14,
    color: '#999999',
    lineHeight: '14px',
    cursor: 'pointer',
    $nest: {
        '& img': {
            width: 13,
            height: 8,
            display: 'inline-block',
            marginLeft: 5
        }
    }
})



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryListItem/CategoryListItem.style.ts